import { FC } from "react";
import { LayerGroup, Polygon } from "react-leaflet";
import { default as countriesGeojson } from "../../utils/countriesGeojson.json";

interface Props {
	color: string;
	borderColor: string;
	exclude?: string[];
	include?: string[];
}

/**
 * Used as a tile layer, returns a layer of countries'polygons
 * built using the "countriesGeojson.json" file
 * [Note]
 * Do not specify both exclude and include :P
 * @param color color of the countries
 * @param borderColor color of the borders aound countries
 * @param exclude if specified, only draws the poygons that **ARE NOT** associated with the specified iso3 codes
 * @param include if specified, only draws the polygons that **ARE** associated with the specified iso3 codes
 * @returns
 */
const DrawnTileLayer: FC<Props> = ({ color, borderColor, exclude, include }) => {
	// options to draw the polygons
	const polyOptions = {
		color: borderColor,
		fillColor: color,
		fillOpacity: 1,
		weight: 1,
	};

	// create polygons based on geometry of included countries
	const polygons = countriesGeojson.countries.map((country, index) => {
		// if we have included countries, only use those
		if (include && include.indexOf(country.properties.iso3) === -1) return <></>;
		// if we have excluded countries, don't use those
		if (exclude && exclude.indexOf(country.properties.iso3) !== -1) return <></>;
		// create the polygons
		return <Polygon key={index} pathOptions={polyOptions} positions={country.geometry}></Polygon>;
	});

	// return the polygons in a layergroup
	return <LayerGroup>{polygons}</LayerGroup>;
};

export default DrawnTileLayer;
